import { gql } from '@apollo/client';

export const DELETE_CART_TEMPLATE = gql`
    mutation DeleteCartTemplate {
        deleteCartTemplate {
            accountId
        }
    }
`;
